import { Plus } from "lucide-react";

/**
 * SlipTemplatesPanel — brand your pack slips (Package B).
 * Lists existing pack-slip HTML templates + a preview + toggles for
 * which columns show. Editor dialog stays in the parent because it
 * lives outside the panel's conditional.
 *
 * Extracted from SellerDropship.jsx in Phase 2 refactor.
 */
export default function SlipTemplatesPanel({
  templatesList, templateDraft, setTemplateDraft,
  saveTemplateB, deleteTemplateB, settings,
  openTemplateEditor, previewTemplateB,
}) {
  return (
  <div className="rounded-2xl border border-border bg-white overflow-hidden" data-testid="fulfillment-templates-panel">
    <div className="px-5 py-3 border-b border-border bg-secondary/40 flex items-center justify-between gap-3">
      <div>
        <div className="text-[13px] font-medium">Pack-slip templates</div>
        <div className="text-[11px] text-foreground/55 mt-0.5">Brand your slips. Logo, colours, header/footer text, barcodes, vendor-SKU column.</div>
      </div>
      <button onClick={() => openTemplateEditor(null)}
        data-testid="template-add"
        className="inline-flex items-center gap-1 h-9 px-3 rounded-full text-[11px] mono uppercase tracking-[0.14em] border border-border bg-white hover:bg-secondary">
        <Plus className="w-3 h-3"/> New template
      </button>
    </div>
    {templatesList.length === 0 ? (
      <div className="p-10 text-center text-[12px] text-foreground/55">
        No templates yet. Add one — pack slips currently use the built-in default layout.
      </div>
    ) : (
      <div className="divide-y divide-border">
        {templatesList.map(t => (
          <div key={t.id} data-testid={`template-${t.id}`} className="px-5 py-3 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="w-3 h-6 rounded" style={{ backgroundColor: t.accent_color }}/>
              <div>
                <div className="text-[13px] font-medium">
                  {t.name}
                  {t.is_default && <span className="ml-2 inline-flex text-[10px] mono uppercase tracking-[0.14em] px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800">Default</span>}
                </div>
                <div className="text-[10.5px] text-foreground/55 mt-0.5">
                  {[
                    t.show_barcodes && "barcode",
                    t.show_vendor_sku && "your-SKU",
                    t.show_prices && "price",
                    t.show_qty_check && "qty-check",
                  ].filter(Boolean).join(" · ") || "minimal"}
                  {t.logo_url && " · with logo"}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-1.5">
              <button onClick={() => previewTemplateB(t.id)}
                data-testid={`template-preview-${t.id}`}
                className="text-[10.5px] mono uppercase tracking-[0.14em] rounded-full h-8 px-3 border border-border hover:bg-secondary">
                Preview
              </button>
              <button onClick={() => openTemplateEditor(t)}
                data-testid={`template-edit-${t.id}`}
                className="text-[10.5px] mono uppercase tracking-[0.14em] rounded-full h-8 px-3 border border-border hover:bg-secondary">
                Edit
              </button>
              <button onClick={() => deleteTemplateB(t.id)}
                data-testid={`template-delete-${t.id}`}
                className="text-[10.5px] mono uppercase tracking-[0.14em] rounded-full h-8 px-3 text-rose-700 hover:bg-rose-50 border border-transparent hover:border-rose-200">
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
  );
}
